/*
 * @Author: YuanYuan
 * @Date: 2024-02-27 18:43:48
 * @LastEditTime: 2025-12-12 10:55:56
 * @description: 证书管理路由定义
 */
import i18n from '@/i18n'

const Meta = {
  leftMenuCode: 'Configurations',
  leftActiveIndex: '/certificates'
}

export default [
  {
    path: '/certificates',
    meta: {
      ...Meta,
      title: i18n.t('menu.certMngmt')
    },
    component: () => import('@/views/certificates/index.vue')
  },
  {
    path: '/certificates/add',
    meta: {
      ...Meta,
      title: i18n.t('certificates.addCert'),
      backable: true
    },
    component: () => import('@/views/certificates/add.vue')
  },
  {
    path: '/certificates/edit',
    meta: {
      ...Meta,
      title: i18n.t('certificates.editCert'),
      backable: true
    },
    component: () => import('@/views/certificates/add.vue')
  },
  {
    path: '/certificates/apply',
    meta: {
      ...Meta,
      title: i18n.t('certificates.oneclickApply'),
      backable: true
    },
    component: () => import('@/views/certificates/apply.vue')
  },
  {
    path: '/certificates/record',
    meta: {
      ...Meta,
      title: i18n.t('certificates.applyRecordQuery'),
      backable: true
    },
    component: () => import('@/views/certificates/record.vue')
  }
]
